<template>
  <div>
    <div class="section-title">
      Gracias por tu interés
    </div>
    <div class="section-content">
      Este proyecto se encuentra en estado de pre-inversión. Tu interés ya fue registrado
      y te enviaremos un correo cuando sea el momento de completar tu inversión. Mientras
      tanto puedes ver otros proyectos que puedan interesarte.
    </div>
    <div class="section-button" style="margin-top: 40px">
      <div class="button" @click="$router.push('/portfolio')">Ver portafólio</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>

</style>
